import React from 'react';
import { CalendarList } from './calendarList';
import { CalendarEvent } from './calendarEvent';
import { ImageTextLink } from '../../imageTextLink';
import { TextLink } from '../../textLink';
import { ImageAlignment } from '../../../../../models';
import { CalendarImage } from '../../../../../assets/images';

interface AddToCalendarLinkProps {
  calendarEvent: CalendarEvent;
  includeImage?: boolean;
}

const AddToCalendarLink: React.FC<AddToCalendarLinkProps> = (
  props: AddToCalendarLinkProps
) => {
  const [isCalendarListVisible, setIsCalendarListVisible] =
    React.useState(false);

  const onlinkClicked = () => {
    setIsCalendarListVisible(true);
  };

  const onClosePopup = () => {
    setIsCalendarListVisible(false);
  };

  return (
    <>
      {props.includeImage === undefined || props.includeImage ? (
        <ImageTextLink
          imageSource={CalendarImage}
          caption="Add to Calendar"
          onClick={onlinkClicked}
          imageAlignment={ImageAlignment.Left}
          allowWrap={false}
        />
      ) : (
        <TextLink
          caption="Add to Calendar"
          onClick={onlinkClicked}
        />
      )}
      {isCalendarListVisible && (
        <CalendarList
          calendarEvent={props.calendarEvent}
          onClosePopup={onClosePopup}
        />
      )}
    </>
  );
};

export default AddToCalendarLink;
